export type Language = {
  value: string;
  name: string;
  flag: string;
  extraCode?: string;
  noLiveTranslation?: boolean;
};

export const EN_LANGUAGES = ['en-US', 'en-AU', 'en'];

export const LANGUAGES: Language[] = [
  { value: 'en-US', name: 'English (USA)', flag: 'US' },
  { value: 'az', name: 'Azəri (Azeri)', flag: 'AZ' },
  { value: 'ar', name: 'عربى (Arabic)', flag: 'SA' },
  { value: 'bn', name: 'বাঙালি (Bengali)', flag: 'BD' },
  { value: 'bg', name: 'Български (Bulgarian)', flag: 'BG' },
  { value: 'zh', name: '中文 (Chinese)', flag: 'CN' },
  {
    value: 'zh-Hant',
    name: '漢語 (Chinese Traditional)',
    flag: 'HK',
    extraCode: 'zh-TW',
  },
  { value: 'hr', name: 'Hrvatski (Croatian)', flag: 'HR' },
  { value: 'cs', name: 'Čeština (Czech)', flag: 'CZ' },
  { value: 'nl', name: 'Nederlands (Dutch)', flag: 'NL' },
  { value: 'en-AU', name: 'English (Australian)', flag: 'AU' },
  { value: 'en', name: 'English (United Kingdom)', flag: 'GB' },
  { value: 'et', name: 'Eesti keel (Estonian)', flag: 'EE' },
  { value: 'fi', name: 'Suomen (Finnish)', flag: 'FI' },
  {
    value: 'fo',
    name: 'Føroyskt (Faroese)',
    flag: 'FO',
    noLiveTranslation: true,
  },
  { value: 'fr', name: 'Français (French)', flag: 'FR' },
  { value: 'ka', name: 'ქართული (Georgian)', flag: 'GE' },
  { value: 'de', name: 'Deutsch (German)', flag: 'DE' },
  { value: 'el', name: 'Ελληνικά (Greek)', flag: 'GR' },
  { value: 'he', name: 'עברית (Hebrew)', flag: 'IL' },
  { value: 'hi', name: 'हिंदी (Hindi)', flag: 'IN' },
  { value: 'hu', name: 'Magyar (Hungarian)', flag: 'HU' },
  { value: 'it', name: 'Italiano (Italian)', flag: 'IT' },
  { value: 'in', name: 'bahasa Indonesia (Indonesian)', flag: 'ID' },
  { value: 'ja', name: '日本語 (Japanese)', flag: 'JP' },
  { value: 'ko', name: '한국어 (Korean)', flag: 'KR' },
  { value: 'lt', name: 'Lietuvių (Lithuanian)', flag: 'LT' },
  {
    value: 'mgo',
    name: 'Crnogorski (Montenegrin)',
    flag: 'ME',
    noLiveTranslation: true,
  },
  { value: 'no', name: 'Norsk (Norwegian)', flag: 'NO' },
  { value: 'fa', name: 'فارسی (Persian)', flag: 'IR' },
  { value: 'pl', name: 'Polski (Polish)', flag: 'PL' },
  { value: 'pt-BR', name: 'Português (Brazil)', flag: 'BR' },
  { value: 'pt', name: 'Português (Portugal)', flag: 'PT' },
  { value: 'pa', name: 'ਪੰਜਾਬੀ (Punjabi)', flag: 'IN' },
  { value: 'ro', name: 'Română (Romanian)', flag: 'RO' },
  { value: 'ru', name: 'Русский (Russian)', flag: 'RU' },
  { value: 'sk', name: 'Slovenský (Slovak)', flag: 'SK' },
  { value: 'sl', name: 'Slovenščina (Slovenian)', flag: 'SI' },
  { value: 'sr', name: 'Српски (Serbian)', flag: 'RS' },
  { value: 'es', name: 'Español (Spanish)', flag: 'ES' },
  { value: 'es-MX', name: 'Español (Mexico)', flag: 'MX' },
  { value: 'sv', name: 'Svenska (Swedish)', flag: 'SE' },
  { value: 'tr', name: 'Türk (Turkish)', flag: 'TR' },
  { value: 'uk', name: 'Українська (Ukrainian)', flag: 'UA' },
  { value: 'cy', name: 'Cymraeg (Welsh)', flag: 'CYM' },
  { value: 'vi', name: 'Việt Nam (Vietnamese)', flag: 'VN' }
];
